export default "/images/vendor/flag-icons/flags/4x3/er.svg?4e8d72f968ec26604a6567ca6c16595c";